const routeConfig = {
	home: '/',
	dashboard: '/dashboard',
	legal: '/legal',
	verifyDocument: '/validate-document',
	// Public landing for the QR printed on the lineage page. Not protected.
	documentLineage: '/d/:ulid',
	policies: '/policies-and-procedures',
	certificateAndCrl: '/certificates-crl',
	consultCertificate: '/consult-certificate',
	requestSignature: '/request-signature',
	mySignatures: '/my-signatures',
	// uploadDocument: "/upload-document",
	redirectLogin: '/login-redirect',
	login: '/login',
	solicitar: '/solicitar',
	test: '/test',
	profile: '/profile',
	customManuscript: '/custom-manuscript',
	contact: '/contact',
	products: '/products-and-services',
	requirements: '/requirements',
	signDocument: '/sign-document',
	signZip: '/sign-zip',
	pinSetup: '/pin-setup',
	myDocuments: '/my-documents',
	mySignatreRequests: '/signature-requests',
	paymentFailure: '/payment-failure',
	verificationStatus: '/verification-status',
};

export default routeConfig;
